import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MatchdayChampionPromo.css';

export default function MatchdayChampionPromo() {
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();

  if (!visible) return null;

  return (
    <div className="mcp-overlay" onClick={() => setVisible(false)}>
      <div className="mcp-banner-wrap" onClick={(e) => e.stopPropagation()}>

        <div className="mcp-banner">

          {/* Top gold separator */}
          <div className="mcp-separator" />

          {/* Green header band */}
          <div className="mcp-green-edge-top" />
          <div className="mcp-green-light-top" />
          <div className="mcp-header-main">
            <span className="mcp-header-text">NEW RELEASE!</span>
          </div>
          <div className="mcp-green-light-bottom" />
          <div className="mcp-green-edge-bottom" />

          {/* Cream content with sunburst + logo */}
          <div className="mcp-cream-edge-top" />
          <div className="mcp-cream-light-top" />
          <div className="mcp-cream-main">
            <img src="/MatchdayChampion/logo.png" alt="Matchday Champion" className="mcp-logo" />
            <p className="mcp-cream-copy">Lead your nation to glory through qualification, league stages, and knockout football tournaments to become Matchday Champion!</p>
          </div>
          <div className="mcp-cream-light-bottom" />
          <div className="mcp-cream-edge-bottom" />

          {/* Green footer band with CONTINUE button */}
          <div className="mcp-footer-edge-top" />
          <div className="mcp-footer-light-top" />
          <div className="mcp-footer-main">
            <button className="mcp-btn-wrap" onClick={() => navigate('/MatchdayChampion')}>
              <span className="mcp-btn-label">CONTINUE</span>
            </button>
          </div>
          <div className="mcp-footer-light-bottom" />
          <div className="mcp-footer-edge-bottom" />

          {/* Bottom gold separator */}
          <div className="mcp-separator" />

        </div>
      </div>
    </div>
  );
}
